module.exports = __webpack_public_path__ + "static/media/money-check-edit.38594a80.svg";